/**
 * The rolling summary the server keeps once a chat gets long. Ellie reads it in
 * place of the turns it covers: every saved row up to `last_id`.
 */
export interface ConversationSummary {
  text: string;
  last_id: number;
}

/** A summary from the network, or null when it is missing or malformed. */
export function conversationSummaryFrom(value: any): ConversationSummary | null {
  const text = typeof value?.text === 'string' ? value.text.trim() : '';
  const lastId = Number(value?.last_id);
  return text && Number.isInteger(lastId) && lastId > 0 ? { text, last_id: lastId } : null;
}

/** Whether the turn saved as row `rowId` is one the summary covers. */
export function summaryCovers(summary: ConversationSummary | null | undefined, rowId: unknown): boolean {
  if (!summary || rowId == null || rowId === '') return false;
  const id = Number(rowId);
  return Number.isFinite(id) && id <= summary.last_id;
}
